import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Card, Typography, Button } from "antd";
import "../Styles/UserStylings/Cancel.css";

const { Title, Text } = Typography;

const Cancel = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { orderId, total, date } = location.state || {};

  return (
    <div className="cancel-page-container">
      <Card className="cancel-card">
        <Title level={2} className="cancel-title">
          Payment Cancelled
        </Title>
        <Text>Your payment was not completed. You can try again.</Text>

        <div className="cancel-details" style={{ marginTop: 15 }}>
          <p><b>Order ID:</b> {orderId}</p>
          <p><b>Total Amount:</b> ₹{total}</p>
          <p><b>Date:</b> {date}</p>
        </div>

        <Button
          type="primary"
          style={{ marginTop: 20 }}
          onClick={() => navigate("/cart")}
        >
          Back to Cart
        </Button>
      </Card>
    </div>
  );
};

export default Cancel;
